import type { CustomFieldAnswer } from "@/domain/custom-fields/types";

interface CustomFieldAnswersProps {
  answers: CustomFieldAnswer[];
}

/** Answers keep the order they were asked in and the label they were asked
 *  under, so a renamed field never relabels what a customer already wrote. */
export function CustomFieldAnswers({ answers }: CustomFieldAnswersProps) {
  return (
    <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
      {answers.map((answer) => (
        <div key={answer.key} className="contents">
          <dt className="text-muted-foreground">{answer.label}</dt>
          <dd className="text-foreground break-words">{answer.value}</dd>
        </div>
      ))}
    </dl>
  );
}
